const ObjectPathImmutable = require("object-path-immutable");

module.exports = ObjectPathImmutable;



// WEBPACK FOOTER //
// ./src/utils/deeply.js